import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=f90b3998&scoped=true&"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&id=f90b3998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90b3998",
  null
  
)

export default component.exports